<template>
  <div class="input-container">
    <textarea
      ref="textarea"
      :rows="rows"
      placeholder="e.g. It's my first time going to Singapore, and I'm interested in trying local food ..."
      :value="textValue"
      @input="handleInput"
      @keydown.enter="handleEnter"
      class="input-container__textarea"
      :class="{active: textValue}"
    ></textarea>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'LargeTextInput',
  data() {
    return {
      textValue: '',
    };
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 1,
    },
    inputValue: {
      type: String,
      default: () => '',
    },
  },
  watch: {
    inputValue(val) {
      this.textValue = val;
      this.focusInput();
      this.$emit('input-change', val);
    },
  },

  methods: {
    handleValue() {},
    handleInput(event) {
      const element = event.target;
      event.target.style.height = '26px';
      element.style.height = element.scrollHeight + 'px';
      this.textValue = this.inputValue;
      this.textValue = event.target.value;
      this.$emit('input-change', event.target.value);
    },
    handleEnter(event) {
      event.preventDefault();
      this.$emit('submit');
    },
    focusInput() {
      this.$refs.textarea.focus();
    },
  },
});
</script>

<style scoped lang="scss">
.input-container {
  max-width: 930px;
  min-height: 85px;
  width: 100%;
  &__textarea {
    width: 100%;
    color: var(--filter-label-color);
    font-size: 22px;
    font-weight: 400;
    line-height: normal;
    border: none;
    outline: none;
    resize: none;
    min-height: 40px;
    &:focus {
      color: var(--primary-dark-color);
    }
  }
}
.active {
  color: var(--primary-dark-color);
}
</style>
